import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { ErrorReference } from '../error/error-reference'
import './sso-workspace.scss'

// Unbinding a domain from a connection, confirmed in the workspace's dialog
// pattern (ConfirmDialog's: modal, Escape and the backdrop cancel, focus
// starts on Cancel). When the connection is ACTIVE and this is its last
// bound domain, unbinding leaves an active connection nobody is sent to
// (it is no longer offered to everyone -- only connections marked public
// are, audit B3), so the dialog says so and offers "Unbind and deactivate"
// as the primary choice (audit B1).
// `failure`: the error behind `error`, for its reference (error-reference.js).
export const UnbindDialog = ({ open, domain, connectionName, lastOfActive, busy, error, failure, onUnbind, onUnbindAndDeactivate, onCancel }) => {
  useEffect(() => {
    if (!open) return undefined
    const onKey = e => { if (e.key === 'Escape') { e.stopPropagation(); onCancel() } }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onCancel])

  if (!open) return null

  return createPortal(
    <div className="sw-drawer justify-content-center align-items-center" onClick={e => { if (e.target === e.currentTarget) onCancel() }}>
      <div className="sw-dialog" role="alertdialog" aria-modal="true" aria-labelledby="sw-unbind-title" aria-describedby="sw-unbind-body">
        <h2 className="h5" id="sw-unbind-title">Unbind {domain}?</h2>
        {lastOfActive
          ? <p className="sw-hint" id="sw-unbind-body">
            {domain} is the last domain bound to {connectionName}, which is active. Without a domain nobody is sent to it, so deactivate it too unless you're about to bind another domain.
          </p>
          : <p className="sw-hint" id="sw-unbind-body">
            People at {domain} stop being sent to {connectionName}. The domain and its verification stay as they are.
          </p>}
        {error && <p className="text-danger small" role="alert">{error}</p>}
        {error && <ErrorReference error={failure} className="mb-3" />}
        <div className="sw-dialog-actions">
          <button type="button" className="btn sw-btn" autoFocus onClick={onCancel}>Cancel</button>
          {lastOfActive
            ? <>
              <button type="button" className="btn sw-btn" disabled={busy} onClick={onUnbind}>Unbind only</button>
              <button type="button" className="btn sw-btn-danger" disabled={busy} onClick={onUnbindAndDeactivate}>Unbind and deactivate</button>
            </>
            : <button type="button" className="btn sw-btn-danger" disabled={busy} onClick={onUnbind}>Unbind</button>}
        </div>
      </div>
    </div>,
    document.body
  )
}
